import React, { useEffect } from 'react';

const CelebrationAnimation = ({ show, onComplete }) => {
  useEffect(() => {
    if (show) {
      // Auto-hide after 4 seconds
      const timer = setTimeout(() => {
        if (onComplete) onComplete();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);

  if (!show) return null;

  return (
    <div className="celebration-overlay">
      {/* Fireworks containers */}
      <div className="fireworks-container">
        <div className="firework" style={{ left: '20%', animationDelay: '0s' }}></div>
        <div className="firework" style={{ left: '50%', animationDelay: '0.5s' }}></div>
        <div className="firework" style={{ left: '80%', animationDelay: '1s' }}></div>
        <div className="firework" style={{ left: '30%', animationDelay: '1.5s' }}></div>
        <div className="firework" style={{ left: '70%', animationDelay: '2s' }}></div>
      </div>

      {/* Floating bubbles */}
      <div className="bubbles-container">
        {[...Array(25)].map((_, i) => (
          <div
            key={i}
            className="bubble"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`,
              backgroundColor: [
                '#ff6b9d', '#c44569', '#f8b500', '#ff9ff3', '#54a0ff',
                '#5f27cd', '#00d2d3', '#ff9999', '#ff6348', '#7bed9f',
                '#70a1ff', '#5352ed', '#ff7675', '#fdcb6e', '#6c5ce7'
              ][Math.floor(Math.random() * 15)]
            }}
          ></div>
        ))}
      </div>

      {/* Confetti */}
      <div className="confetti-container">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="confetti"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              backgroundColor: [
                '#E91E63', '#FF1493', '#FF6B9D', '#C44569', '#F8B500',
                '#54A0FF', '#5F27CD', '#00D2D3', '#7BED9F', '#FF9999'
              ][Math.floor(Math.random() * 10)]
            }}
          ></div>
        ))}
      </div>

      {/* Success message */}
      <div className="celebration-message">
        <div className="success-icon">🎉</div>
        <h2>Order Placed Successfully!</h2>
        <p>Get ready for some delicious boba!</p>
      </div>

      <style jsx>{`
        .celebration-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          z-index: 9999;
          pointer-events: none;
          overflow: hidden;
        }

        .fireworks-container {
          position: absolute;
          width: 100%;
          height: 100%;
        }

        .firework {
          position: absolute;
          bottom: 0;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: linear-gradient(45deg, #ff6b9d, #c44569);
          animation: firework 3s ease-out infinite;
        }

        @keyframes firework {
          0% {
            bottom: 0;
            opacity: 1;
            transform: scale(1);
          }
          15% {
            bottom: 60vh;
            opacity: 1;
          }
          17% {
            opacity: 0;
            transform: scale(1);
          }
          18% {
            opacity: 0;
            transform: scale(0);
            box-shadow: 
              0 0 0 0 #ff6b9d,
              0 0 0 0 #c44569,
              0 0 0 0 #f8b500,
              0 0 0 0 #ff9ff3,
              0 0 0 0 #54a0ff;
          }
          20% {
            opacity: 1;
            transform: scale(15);
            box-shadow: 
              -100px 0 20px 0 #ff6b9d,
              100px 0 20px 0 #c44569,
              0 -100px 20px 0 #f8b500,
              0 100px 20px 0 #ff9ff3,
              -70px -70px 20px 0 #54a0ff,
              70px -70px 20px 0 #5f27cd,
              -70px 70px 20px 0 #00d2d3,
              70px 70px 20px 0 #ff9999;
          }
          30% {
            opacity: 0.5;
            transform: scale(20);
          }
          100% {
            opacity: 0;
            transform: scale(25);
          }
        }

        .bubbles-container {
          position: absolute;
          width: 100%;
          height: 100%;
        }

        .bubble {
          position: absolute;
          bottom: -50px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          opacity: 0.8;
          animation: bubble 4s ease-out infinite;
        }

        @keyframes bubble {
          0% {
            bottom: -50px;
            transform: translateX(0) scale(0);
            opacity: 0;
          }
          10% {
            opacity: 0.8;
            transform: scale(1);
          }
          90% {
            opacity: 0.8;
          }
          100% {
            bottom: 100vh;
            transform: translateX(${Math.random() > 0.5 ? '' : '-'}100px) scale(1.5);
            opacity: 0;
          }
        }

        .confetti-container {
          position: absolute;
          width: 100%;
          height: 100%;
        }

        .confetti {
          position: absolute;
          top: -10px;
          width: 10px;
          height: 10px;
          animation: confetti 3s ease-out infinite;
        }

        @keyframes confetti {
          0% {
            top: -10px;
            transform: rotateZ(0deg) rotateY(0deg);
            opacity: 1;
          }
          100% {
            top: 100vh;
            transform: rotateZ(720deg) rotateY(360deg);
            opacity: 0;
          }
        }

        .celebration-message {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          background: rgba(255, 255, 255, 0.95);
          padding: 40px;
          border-radius: 20px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
          animation: messagePopIn 0.6s ease-out;
          pointer-events: auto;
          border: 3px solid #E91E63;
          backdrop-filter: blur(10px);
        }

        @keyframes messagePopIn {
          0% {
            transform: translate(-50%, -50%) scale(0.5);
            opacity: 0;
          }
          50% {
            transform: translate(-50%, -50%) scale(1.1);
          }
          100% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
        }

        .success-icon {
          font-size: 4rem;
          margin-bottom: 20px;
          animation: bounce 1s ease-in-out infinite alternate;
        }

        @keyframes bounce {
          0% {
            transform: translateY(0) scale(1);
          }
          100% {
            transform: translateY(-10px) scale(1.1);
          }
        }

        .celebration-message h2 {
          color: #E91E63;
          font-size: 2rem;
          margin-bottom: 10px;
          font-weight: bold;
        }

        .celebration-message p {
          color: #666;
          font-size: 1.1rem;
          margin: 0;
        }

        /* Different bubble sizes */
        .bubble:nth-child(3n) {
          width: 15px;
          height: 15px;
        }

        .bubble:nth-child(5n) {
          width: 25px;
          height: 25px;
        }

        .bubble:nth-child(7n) {
          width: 30px;
          height: 30px;
        }

        /* Different confetti shapes */
        .confetti:nth-child(2n) {
          border-radius: 50%;
        }

        .confetti:nth-child(3n) {
          width: 6px;
          height: 15px;
          border-radius: 3px;
        }

        .confetti:nth-child(4n) {
          width: 15px;
          height: 6px;
          border-radius: 3px;
        }

        @media (max-width: 768px) {
          .celebration-message {
            padding: 30px 20px;
            max-width: 90%;
          }

          .celebration-message h2 {
            font-size: 1.5rem;
          }

          .success-icon {
            font-size: 3rem;
          }
        }
      `}</style>
    </div>
  );
};

export default CelebrationAnimation; 